import React from 'react'
import styles from './styles.module.css'
import Table from '../../../components/Table'
import { useSelector } from 'react-redux';
import Loader from '../../../components/Loader';
import moment from 'moment';

const Tables = ({ modalOpen }) => {

    const { list = [], loading } = useSelector(state => state.planning);

    const handleOpenPopup = (item) => {
        modalOpen(item);
    }

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return moment(dateStr).format('DD.MM.YYYY');
    }

    const getDayName = (dateStr) => {
        if (!dateStr) return '';
        const days = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];
        const dayIndex = moment(dateStr).day();
        return days[dayIndex];
    }

    return (
        <div className={styles.wrapper}>
            {loading ? <Loader /> :
                <Table>
                    <thead>
                        <tr>
                            <th>Дата</th>
                            <th>Предмет</th>
                            <th>Тема урока</th>
                            <th>Кабинет</th>
                            <th>Урок</th>
                            <th>Класс</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list?.map((item, index) => (
                            <tr key={index} className={styles.tableRow} onClick={() => handleOpenPopup(item)}>
                                <td>
                                    <div>{formatDate(item.day)}</div>
                                    <div className={styles.dayName}>{getDayName(item.day)}</div>
                                </td>
                                <td>
                                    <div>{item.course}</div>
                                    {item.otitle && <div className={styles.theme}>Тема: {item.otitle}</div>}
                                </td>
                                <td>{item.otitle || 'Тема урока не задана'}</td>
                                <td>{item.room}</td>
                                <td>{item.period}</td>
                                <td>{item.groupname}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            }
            {(list?.length === 0 && !loading) && <div className={styles.noData}>Нет данных</div>}
        </div>
    )
}

export default Tables
